import React from 'react';

import { OutlinedInput as MUIOutlinedInput } from '@mui/material';
import styled from 'styled-components';

import { Select } from './select';

const TableSelectInput = styled(MUIOutlinedInput)`
  .MuiInputBase-input {
    padding: var(--sizes-20) var(--sizes-40);
    font: var(--font-extra-small-12pt-normal);
    display: flex;
    align-items: center;
  }

  .MuiSelect-icon {
    top: 0.875rem;
    height: 7px; // keep as px to be in sync with the icon file
    width: 14px; // keep as px to be in sync with the icon file
    margin: 0;
  }
`;

export function TableSelect(props) {
  return <Select {...props} input={<TableSelectInput />} />;
}
